import { inject, Pipe, PipeTransform } from "@angular/core";

import { MedicalIconService } from "./medical-icon.service";

@Pipe({
	name: "mediconColor",
	standalone: false,
})
export class MedicalIconColorPipe implements PipeTransform {
	private iconService = inject(MedicalIconService);

	transform(value: string): string {
		// @ts-expect-error TS2322
		return this.iconService.getColor(value);
	}
}
